<template>
  <div class="py-3">
    <div class="offer-groups-header">
      <v-progress-circular
        :width="16"
        :rotate="-90"
        :value="completion"
        color="blue-grey"
      />
      <h3 class="ml-2">{{ group.name }}</h3>
      <v-divider class="my-2 ml-2" />
    </div>
    <div class="offer-groups-documents">
      <v-list-item v-for="(document, index) in documents" :key="index">
        <OfferDocumentList :document="document" />
      </v-list-item>
    </div>
  </div>
</template>

<script>
import OfferDocumentList from "@/views/offers/components/OfferDocumentList";
import { size, filter } from "lodash";

export default {
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  components: { OfferDocumentList },
  computed: {
    documents() {
      return this.group.documents;
    },
    completion() {
      const totalDocuments = size(this.documents);
      const completedDocuments = size(
        filter(this.documents, document => document.status === "approved")
      );
      return (completedDocuments / totalDocuments) * 100;
    }
  }
};
</script>

<style lang="scss">
.offer-groups {
  &-header {
    display: flex;
    align-content: center;
  }
}
</style>
